export var getZoomedState = function getZoomedState(_ref) {
  var areBoundsChangedProgramatically = _ref.areBoundsChangedProgramatically;
  return areBoundsChangedProgramatically ? {
    areBoundsChangedProgramatically: false
  } : {
    isZoomed: true
  };
};